// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__2cFvk","home__row":"home_home__row__3OApq","title":"home_title__1rd5P","__or":"home___or__3Yhjf","__subtitle":"home___subtitle__3toHf"};